<template>
    <div
        class="flex flex-1 flex-col border p-4"
        data-testid="start-player-card"
        :data-selected="isSelected"
        :data-player-name="player.tag_name"
        :class="[isSelected ? 'border-green-500 bg-green-600' : 'bg-bg border-stroke-1']"
        @click="$emit('select', player)"
    >
        <div class="relative flex flex-1 flex-col items-center justify-center space-y-2">
            <Avatar
                :src="player.avatar"
                class="aspect-square max-h-22 flex-1 object-cover"
                size="h-full"
            />
            <h3 class="font-bold">
                <span class="line-clamp-1 max-w-40 truncate">{{ player.tag_name }}</span>
            </h3>
            <h2 class="absolute top-0 right-0 text-xl font-bold uppercase">
                {{ isSelected ? '1st' : '&nbsp;' }}
            </h2>
        </div>
    </div>
</template>

<script>
import Avatar from '../Avatar.vue'

export default {
    name: 'PlayerStartCard',
    props: {
        player: {
            type: Object,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        hasSelection: {
            type: Boolean,
            default: false,
        },
        isShuffling: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            required: false,
            default: 2,
        },
    },
    components: {
        Avatar,
    },
    emits: ['select'],
}
</script>
